import { lazy } from 'react';

import IRoute from 'Shared/Routes/Models/IRoute';

import { LifeInsuPaths } from './LifeInsuPaths';

const LifeInformationAndPayPage = lazy(() => import('../LifeInformationAndPay/LifeInformationAndPayPage'));

export const LifeInsuRoutes: IRoute[][] = [
  [
    {
      path: LifeInsuPaths.BimehNameh.InformationAndPay,
      component: LifeInformationAndPayPage,
      needAuth: true,
    },
  ],
];
